import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import CustomSelect from '../CustomSelect';
import { SelectWrapper } from './style';
import { getSortingOptions } from '../../../utils/labels';

const defaultOpts = getSortingOptions([
  'created_desc',
  'alphabetical',
]);

const SortBy = ({ options, onChange, className, disabled }) => {
  const [opts, setOpts] = useState(defaultOpts);
  const [selected, setSelected] = useState(opts[0]);

  useEffect(() => {
    if (options?.length > 0) {
      setOpts(options);
      setSelected(options[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options?.length]);

  return (
    <SelectWrapper className={className}>
      <Text type="b3" className="fit-content">
        Ordina per:
      </Text>
      <CustomSelect
        options={opts}
        selected={selected}
        onChange={(v) => {
          setSelected(v);
          onChange(v);
        }}
        disabled={disabled}
      />
    </SelectWrapper>
  );
};

SortBy.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SortBy;
